import ActionButton from '@repo/ui/action-button'
import { DragHandleProps } from '@repo/ui/draggable-list'
import { DeleteIcon, DragIcon, PenIcon } from '@repo/ui/icons'
import { ReactNode } from 'react'

interface Props {
  isDragging?: boolean
  dragHandleProps?: DragHandleProps
  content: ReactNode
  isDeleting?: boolean
  onClick?: () => void
  onEdit?: () => void
  onDelete?: () => void
}

const DraggableListCard = ({
  isDragging,
  dragHandleProps,
  content,
  isDeleting,
  onClick,
  onEdit,
  onDelete
}: Props) => {
  return (
    <div
      className={`flex items-center gap-3 p-4 bg-white-hover border border-grey-light rounded-lg shadow-sm hover:shadow-md transition-shadow ${isDragging ? 'shadow-lg opacity-75' : ''}`}
    >
      <div
        {...dragHandleProps}
        {...dragHandleProps?.listeners} // I had to spread the listeners to make the drag handle work
        className="flex items-center justify-center w-6 h-6 text-gray-400 cursor-grab active:cursor-grabbing"
      >
        <DragIcon className="scale-125" />
      </div>

      <div
        className="flex-1 flex items-center justify-between cursor-pointer"
        onClick={() => onClick?.()}
      >
        <div className="flex-1">{content}</div>

        {(onEdit || onDelete) && (
          <div className="flex items-center gap-2 ml-4">
            {onDelete && (
              <ActionButton
                variant="danger"
                icon={DeleteIcon}
                onClick={(e) => {
                  e.stopPropagation()
                  onDelete()
                }}
                isLoading={isDeleting}
              />
            )}
            {onEdit && (
              <ActionButton
                variant="primary"
                icon={PenIcon}
                onClick={(e) => {
                  e.stopPropagation()
                  onEdit()
                }}
              />
            )}
          </div>
        )}
      </div>
    </div>
  )
}

export default DraggableListCard
